import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full relative" }
const _hoisted_2 = { class: "flex flex-col md:flex-row w-full items-stretch p-1 bg-gray-100 rounded-lg shadow-inner relative" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_ctx.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "absolute bg-white rounded-md shadow transition-all duration-300 ease-out",
            style: _normalizeStyle(_ctx.sliderStyle)
          }, null, 4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "flex-1 text-center relative z-10 w-full",
          onClick: ($event: any) => (_ctx.selectItem(index))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["block w-full py-2 text-sm transition-all font-medium cursor-pointer", _ctx.activeIndex === index ? 'text-gray-800' : 'text-gray-500'])
          }, _toDisplayString(item), 3)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}